import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { ColumnDef } from "@/components/molecules/DataTable";
import {
  formatUnifiedDate,
  kindClass,
  kindLabel,
  type UnifiedRow,
} from "../adapters/toUnifiedRow";

export const unifiedColumns: ColumnDef<UnifiedRow>[] = [
  {
    id: "kind",
    header: "Type",
    width: "w-[90px]",
    cell: (row) => (
      <Badge
        variant="outline"
        className={cn("text-xs py-0 px-1.5", kindClass[row.kind])}
      >
        {kindLabel[row.kind]}
      </Badge>
    ),
    sortValue: (row) => kindLabel[row.kind],
  },
  {
    id: "title",
    header: "Title",
    cell: (row) => (
      <span className="truncate max-w-[220px] block" title={row.title}>
        {row.title}
      </span>
    ),
    sortValue: (row) => row.title,
  },
  {
    id: "path",
    header: "Path",
    cell: (row) => (
      <span className="truncate max-w-[200px] block" title={row.path}>
        {row.path}
      </span>
    ),
    sortValue: (row) => row.path,
  },
  {
    id: "status",
    header: "Status",
    width: "w-[150px]",
    cell: (row) =>
      row.status === "-" ? (
        <span className="text-muted-foreground">-</span>
      ) : (
        <Badge
          variant="outline"
          className={cn("text-xs py-0 px-1.5 whitespace-nowrap", row.statusTone)}
        >
          {row.status}
        </Badge>
      ),
    sortValue: (row) => row.status,
  },
  {
    id: "score",
    header: "Score",
    width: "w-[80px]",
    cell: (row) =>
      row.score === null ? (
        <span className="text-muted-foreground">-</span>
      ) : (
        <Badge className="text-xs py-0 px-2">{row.score}</Badge>
      ),
    sortValue: (row) => row.score ?? -1,
  },
  {
    id: "date",
    header: "Date",
    width: "w-[120px]",
    cell: (row) => (
      <span className="text-muted-foreground text-xs">
        {formatUnifiedDate(
          row.date as Date | { toDate?: () => Date } | null | undefined,
        )}
      </span>
    ),
    sortValue: (row) => {
      if (!row.date) return 0;
      const d = row.date as Date | { toDate?: () => Date };
      try {
        if (d instanceof Date) return d.getTime();
        return typeof d.toDate === "function" ? d.toDate().getTime() : 0;
      } catch {
        return 0;
      }
    },
  },
];
